"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttributeValueChanges = void 0;
const ramda_1 = require("ramda");
const attributes_1 = require("../../../constants/attributes");
const getAttributeValueChanges = (newValues, prevValues, specialAttributeValueLabel) => {
    /*
      Unknown is a system value indicating that the attribute has no values.
      It is not a real value and can neither be removed nor added to the product.
    */
    let valuesToDeleteSet = new Set((0, ramda_1.without)([attributes_1.SpecialAttributeValue.Unknown, ...newValues], prevValues));
    const valuesToCreateSet = new Set((0, ramda_1.without)([attributes_1.SpecialAttributeValue.Unknown, ...prevValues], newValues));
    const processedNewValuesSet = new Set(newValues);
    const valuesToCreateContainsNA = valuesToCreateSet.has(specialAttributeValueLabel);
    const prevValuesContainsNA = prevValues.includes(specialAttributeValueLabel);
    const newValuesContainsNA = newValues.includes(specialAttributeValueLabel);
    // Case 1: When only one new value is added and it's N/A - delete all other values
    if (valuesToCreateSet.size === 1 && valuesToCreateContainsNA) {
        valuesToDeleteSet = new Set(prevValues.filter((value) => value !== specialAttributeValueLabel
            && value !== attributes_1.SpecialAttributeValue.Unknown));
    }
    else if (newValuesContainsNA) {
        // Case 2: When new values contains N/A, but new values array size is more than one - do not create N/A
        valuesToCreateSet.delete(specialAttributeValueLabel);
        processedNewValuesSet.delete(specialAttributeValueLabel);
        // Case 3: When new values are added and the prev values contains N/A - remove N/A
        if (prevValuesContainsNA) {
            valuesToDeleteSet.add(specialAttributeValueLabel);
        }
    }
    const processedNewValues = Array.from(processedNewValuesSet).filter((value) => !valuesToDeleteSet.has(value));
    return {
        valuesToCreate: Array.from(valuesToCreateSet),
        valuesToDelete: Array.from(valuesToDeleteSet),
        processedNewValues,
    };
};
exports.getAttributeValueChanges = getAttributeValueChanges;
